import * as ActionTypes from "../Types/ActionTypes";

export const Pincodes = (
  state = {
    isLoading: true,
    errMess: null,
    pincodes: [],
    pincodePendingCases: {
      isLoading: true,
      errMess: null,
      data: null,
    },
    branchPendingCases: {
      isLoading: true,
      errMess: null,
      data: null,
    },
    branchInspectionReport: {
      isLoading: true,
      errMess: null,
      data: null,
    },
    branchRescheduleFail: {
      isLoading: true,
      errMess: null,
      data: null,
    },
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_PINCODES:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        pincodes: action.payload,
      };

    case ActionTypes.PINCODES_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        pincodes: [],
      };

    case ActionTypes.PINCODES_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        pincodes: [],
      };

    case ActionTypes.FETCH_PINCODE_PENDING_CASES:
      return {
        ...state,
        pincodePendingCases: {
          isLoading: false,
          errMess: null,
          data: action.payload,
        },
      };

    case ActionTypes.PINCODE_PENDING_CASES_LOADING:
      return {
        ...state,
        pincodePendingCases: {
          ...state.pincodePendingCases,
          isLoading: true,
          errMess: null,
        },
      };

    case ActionTypes.PINCODE_PENDING_CASES_FAILED:
      return {
        ...state,
        pincodePendingCases: {
          ...state.pincodePendingCases,
          isLoading: false,
          errMess: action.payload,
          data: null,
        },
      };

    case ActionTypes.FETCH_BRANCH_PENDING_CASES:
      return {
        ...state,
        branchPendingCases: {
          isLoading: false,
          errMess: null,
          data: action.payload,
        },
      };

    case ActionTypes.BRANCH_PENDING_CASES_LOADING:
      return {
        ...state,
        branchPendingCases: {
          ...state.branchPendingCases,
          isLoading: true,
          errMess: null,
        },
      };

    case ActionTypes.BRANCH_PENDING_CASES_FAILED:
      return {
        ...state,
        branchPendingCases: {
          ...state.branchPendingCases,
          isLoading: false,
          errMess: action.payload,
          data: null,
        },
      };

    case ActionTypes.FETCH_BRANCH_INSPECTION_REPORT:
      return {
        ...state,
        branchInspectionReport: {
          isLoading: false,
          errMess: null,
          data: action.payload,
        },
      };

    case ActionTypes.BRANCH_INSPECTION_REPORT_LOADING:
      return {
        ...state,
        branchInspectionReport: {
          ...state.branchInspectionReport,
          isLoading: true,
          errMess: null,
        },
      };

    case ActionTypes.BRANCH_INSPECTION_REPORT_FAILED:
      return {
        ...state,
        branchInspectionReport: {
          ...state.branchInspectionReport,
          isLoading: false,
          errMess: action.payload,
          data: null,
        },
      };

    case ActionTypes.FETCH_BRANCH_RESVHEdule_FAIL:
      return {
        ...state,
        branchRescheduleFail: {
          isLoading: false,
          errMess: null,
          data: action.payload,
        },
      };

    case ActionTypes.BRANCH_RESVHEdule_FAIL_LOADING:
      return {
        ...state,
        branchRescheduleFail: {
          ...state.branchRescheduleFail,
          isLoading: true,
          errMess: null,
        },
      };

    case ActionTypes.BRANCH_RESVHEdule_FAIL_FAILED:
      return {
        ...state,
        branchRescheduleFail: {
          ...state.branchRescheduleFail,
          isLoading: false,
          errMess: action.payload,
          data: null,
        },
      };

    default:
      return state;
  }
};